import Axios from '../utils/axios-utils';

// create Tire
export const createTire = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/tires`, {
            vendorId: data.vendorId,
            brand: data.brand,
            model: data.model,
            tin: data.tin,
            size: data.size,
            season: data.season,
            rim: data.rim,
            note: data.note,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create Tire error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create Tire failed" }
        };
    }
};

// get all (assinged / unaisigned) Tire
export const getAllTypeTires = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire failed" }
        };
    }
};

// get all Tire
export const getAllTires = async (accountId, assigned=false) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires`, {
            params: {
                assigned: assigned,
            },
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire failed" }
        };
    }
};

// update Tire
export const updateTire = async (accountId, tireId, data) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/tires/${tireId}`, data);
        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Tire error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Tire failed" }
        };
    }
};

// delete Tire
export const deleteTire = async (accountId, tireId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/tires/${tireId}`);
        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Tire error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Tire failed" },
            status: error.response?.status || 500
        };
    }
};

// update Tire status
export const updateTireStatus = async (accountId, tireId, status) => {
    try {
        const response = await Axios.patch(`/accounts/${accountId}/tires/${tireId}/status`, {
            status,
        });

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Update Tire Status error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Update Tire Status failed" }
        };
    }
};

// get all Tire statuses
export const getAllTireStatuses = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/statuses`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire statuses error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire statuses failed" }
        };
    }
};

// get all Tire Brands
export const getAllTireBrands = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/brands`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire brands error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire brands failed" }
        };
    }
};

// get all Tire sizes
export const getAllTireSizes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/sizes`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire sizes error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire sizes failed" }
        };
    }
};

// get all Tire seasons
export const getAllTireSeasons = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/seasons`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire seasons error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire seasons failed" }
        };
    }
};

// get all Tire positions
export const getAllTirePositions = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/positions`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Tire positions error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Tire positions failed" }
        };
    }
};

// get  tire media
export const getTireMedia = async (accountId, tireId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/tires/${tireId}/media`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get tire media error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get tire media failed" }
        };
    }
};